import { Controller } from "@hotwired/stimulus"
import { planningMutation } from "../planning_mutation"

// Note editor for a trade demand on the capacity board (Planning::DemandNoteDialogComponent).
// Opens on the `planning:edit-demand-note` document event (dispatched by the delegated board
// controller when a chip's note button is clicked) with { url, text }. Speichern PATCHes the note
// and renders the returned Turbo Stream; an empty note removes it. Cmd/Ctrl+Enter saves. Without plan
// permission the component renders no submit target and the dialog only shows the note.
export default class extends Controller {
  static targets = ["root", "text", "submit"]

  connect() {
    this.url = null
    this.boundOpen = this.open.bind(this)
    this.boundKeydown = this.onKeydown.bind(this)
    document.addEventListener("planning:edit-demand-note", this.boundOpen)
  }

  disconnect() {
    document.removeEventListener("planning:edit-demand-note", this.boundOpen)
    document.removeEventListener("keydown", this.boundKeydown)
  }

  open(event) {
    const detail = event.detail || {}
    this.url = detail.url
    this.textTarget.value = detail.text || ""

    this.rootTarget.classList.remove("hidden")
    this.rootTarget.classList.add("flex")
    document.addEventListener("keydown", this.boundKeydown)
    this.textTarget.focus()
  }

  close() {
    this.rootTarget.classList.add("hidden")
    this.rootTarget.classList.remove("flex")
    this.url = null
    if (this.hasSubmitTarget) this.submitTarget.disabled = false
    document.removeEventListener("keydown", this.boundKeydown)
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
  }

  keydown(event) {
    if (event.key === "Enter" && (event.metaKey || event.ctrlKey)) {
      event.preventDefault()
      this.save()
    }
  }

  backdrop(event) {
    if (event.target === this.rootTarget) this.close()
  }

  async save() {
    // The disabled button only stops clicks; a second Cmd+Enter must not send the PATCH again.
    if (!this.url || !this.hasSubmitTarget || this.submitTarget.disabled) return
    this.submitTarget.disabled = true
    const { ok } = await planningMutation({
      url: this.url,
      method: "PATCH",
      body: { notes: this.textTarget.value },
      component: "planning-demand-note-dialog",
    })
    if (ok) {
      this.close()
    } else {
      this.submitTarget.disabled = false
    }
  }
}
